import React, { useContext, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Loader } from "rsuite";
import { LanguageContext } from "../../app/context";
import type { ActivityType } from "../../entities/Activity/types/activityType";
import { useGetLessonByIdQuery } from "../../entities/Lesson/lessonApi";
import { ActivityRouter } from "../../features/activities/components/ActivityRouter/ActivityRouter";
import { PointsDisplay } from "../../shared/components/PointsDisplay/PointsDisplay";
import style from "./ActivityPage.module.scss";

const ActivityPage = () => {
	const { id: activityId = "" } = useParams();
	const location = useLocation();
	const queryParams = new URLSearchParams(location?.search);

	const lessonId = queryParams.get("lesson_id") as string;

	const { data: activitiesByLesson, isLoading = false } =
		useGetLessonByIdQuery(lessonId);

	const activity = activitiesByLesson?.activities?.find(
		(activity) => activity._id === activityId,
	);

	const { setLanguage } = useContext(LanguageContext);

	useEffect(() => {
		if (activity?.language) {
			setLanguage(activity.language);
		}
	}, [activity?.language, setLanguage]);

	if (isLoading) {
		return <Loader center content="loading" vertical />;
	}

	return (
		<div className={style.activityPage}>
			<PointsDisplay />
			{
				<ActivityRouter
					activity={
						activity as unknown as {
							details: { customActivities: ActivityType[] };
						}
					}
				/>
			}
		</div>
	);
};

export default ActivityPage;
